import BaseApi, { API_VERSION, ServerListRequest, cleanParams } from '@lumapps/base-api';

import type { ProviderListResponse } from '../types';

export interface FetchProviderListFilters {
    providerType?: string;
    providerTypes?: string[];
}

export interface FetchProviderListAPIParams extends FetchProviderListFilters, ServerListRequest {}

/**
 * Base API instance for providers.
 */
const providersAPI = new BaseApi({ path: 'providers', version: API_VERSION.v2 });

/**
 * Fetch the provider list.
 */
export const fetchProviderList = (params: FetchProviderListAPIParams, fetchKey?: string) =>
    providersAPI.get<ProviderListResponse>(
        '',
        { params: cleanParams({ ...params, providerTypes: params.providerTypes?.join(',') }) },
        undefined,
        fetchKey !== undefined,
        fetchKey,
    );

/**
 * Cancel the providers list
 * @param { string } fetchKey - The request identifier.
 */
export const cancelProviderList = (fetchKey: string): void => {
    return providersAPI.cancel('', undefined, fetchKey);
};
